import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    window.$(".field > .calendar").calendar({ type: "date" });
  }
}
